/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

import $ from "./app/jquery-shim";

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {

  }
  growApp.prototype.enterAnimation = function () {

    if (!$('.c-loader').length){
      return false;
    }

    var $loader = document.querySelector(".c-loader");
    var $body = document.querySelector("body");
    var $loaderTitle = document.querySelector(".c-loader__lg-title");
    var $loaderTitleOverlay = document.querySelector(".c-loader__main-overlay");
    var $loaderMainTitle = document.querySelector(".c-loader__main-title");
    var $mainVisualButton = document.querySelector(".c-main-visual__button");

    var win = $(window).innerWidth();
    if (win < 950) {
      $loader.classList.add('is-loaded');
      $mainVisualButton.classList.add('is-visible');
      return false;
    }




    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.classList.add(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function() {
      // ここから実行
      if ($loader) {
        changeClass($body, "is-visible", 500).then(function () {
          changeClass($loaderTitle, "is-visible", 500).then(function () {
            changeClass($loaderTitleOverlay, "is-visible", 1000).then(function () {
              changeClass($loaderMainTitle, "is-visible", 0).then(function () {
                changeClass($loader, "is-hide", 2500).then(function () {
                  changeClass($body, "is-scroll", 0).then(function () {
                    changeClass($mainVisualButton, "is-visible", 1500).then(function () {
                    });
                  });
                });
              });
            });
          });
        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      // loaderFunction();
      $loader.classList.add('is-loaded');
      $mainVisualButton.classList.add('is-visible');

    }

  };


  growApp.prototype.currentOption = function () {
    var body = $('body');
    var currentClassNurse = $('.js-current-nav.is-nurse');
    var currentClassTherapy = $('.js-current-nav.is-therapy');

    if (body.hasClass('nurse')){
      currentClassNurse.addClass('is-current');
    }
    if (body.hasClass('therapy')){
      currentClassTherapy.addClass('is-current');
    }
  };

  growApp.prototype.bradcrumbOption = function () {
    var body = $('body');
    var breadNav = $('.c-breadcrumb');
    var breadNavCurrent = $('.c-breadcrumb .is-option');

    if (body.hasClass('three-level')){
      breadNavCurrent.addClass('is-over');
    }
  };


  $(function () {
    var app = new growApp();
    app.myCode();
    app.enterAnimation();
    app.currentOption();
    app.bradcrumbOption();
  });
})(jQuery);
